<template>
  <nd-dialog v-model="visible" :footer="false">
    <div class="content download-guide" slot="custom">
      <img src="@/components/nd-dialog/images/btn_close.png" @click="close" />
      <svg class="svg" width="100" height="200">
        <line
          x1="93"
          x2="85"
          y1="25"
          y2="10"
          stroke="white"
          fill="transparent"
          stroke-width="3"
          stroke-linecap="round"
        />
        <line
          x1="75"
          x2="85"
          y1="25"
          y2="10"
          stroke="white"
          fill="transparent"
          stroke-width="3"
          stroke-linecap="round"
        />
        <path
          d="M10 180 Q 85 100 85 10"
          stroke="white"
          stroke-width="3"
          fill="transparent"
          stroke-linecap="round"
        />
      </svg>
      <div class="steps">
        <p class="unit">① 点击右上角的 <span>...</span></p>
        <p class="unit">{{ tips }}</p>
      </div>
    </div>
  </nd-dialog>
</template>

<script>
export default {
  data () {
    return {
      visible: false
    }
  },
  methods: {
    open () {
      this.visible = true
    },
    close () {
      this.visible = false
    }
  },
  computed: {
    // 提示
    tips () {
      const userAgent = navigator.userAgent
      const isAndroid =
        userAgent.indexOf('Android') > -1 ||
        userAgent.indexOf('Adr') > -1 // android终端
      const isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      const isIpad = userAgent.indexOf('iPad') > -1
      if (isAndroid) {
        return '② 选择在浏览器中打开'
      } else if (isiOS || isIpad) {
        return '② 在Safari中打开'
      } else {
        return '② 选择在浏览器中打开'
      }
    }
  }
}
</script>

<style lang="less">
@import "../../../assets/less/mixin.less";

.content.download-guide {
    width: 100vw;
    height: 100vh;
    > img {
        width: 56px;
        height: 56px;
        position: absolute;
        top: 100px;
        left: 50px;
    }
    .svg {
        position: absolute;
        right: 15px;
        top: 0;
    }
    .steps {
        width: 100%;
        position: absolute;
        top: 320px;
        .unit {
            position: relative;
            color: white;
            width: 100%;
            padding: 0 50px;
            z-index: 1000;
            line-height: 1;
            margin: 50px 0;
            font-size: 40px;
            span {
                position: relative;
                bottom: 7px;
            }
        }
    }
}
</style>
